export default __webpack_public_path__ + "static/media/Pregacap-75-ban.8d837f22.jpg";